import { isValidPhoneNumber } from "../../phone-input"

export const DELIVERY_NAME = "shipping_method"
export const RECIPIENT_NAME = "another_recipient"
export const COUPON = "coupon"
// export const nameValidation = { required: true, minLength: 2, maxLength: 255 };
export const defaultValidation = { required: true }
// export const emailValidation = {
//   required: true,
//   pattern: /^([\w-.]+@([\w-]+\.)+[\w-]{2,4})?$/,
// };
// export const phoneValidation = { required: true, minLength: 17 };
export const email = "email"
export const phone = "phone"
export const cityInputName = "novaPoshtaCity"
export const deliveryExtra = "delivery_extra"
export const alphaBankCardValidation = {
  required: true,
  pattern: /^-?\d+$/,
  minLength: 4,
  maxLength: 4,
}
const cyrOnlyPattern = /^(?![\d\s]+$)[а-яА-ЯЇїІіЄє0-9-.,'&/() ]*$/
const latinOnlyPattern = /^(?![\d\s]+$)[a-zA-Z0-9-.,'&/() ]*$/
const allSymbolsPattern = /^.*$/
const allExceptCyrillicPattern = /^[^а-яА-Я]*$/
const emailPattern = /^([\w-.]+@([\w-]+\.)+[\w-]{2,4})?$/

export const validationRules = {
  default: {
    required: true,
  },
  // Personal data
  email: {
    required: true,
    pattern: emailPattern,
  },
  name: {
    required: true,
    minLength: 2,
    maxLength: 255,
    pattern: cyrOnlyPattern,
  },
  name_with_another_recipient: {
    required: true,
    minLength: 2,
    maxLength: 255,
    pattern: null,
  },
  name_intl: {
    required: true,
    minLength: null,
    maxLength: null,
    pattern: latinOnlyPattern,
  },
  surname: {
    required: true,
    minLength: 2,
    maxLength: 255,
    pattern: cyrOnlyPattern,
  },
  surname_with_another_recipient: {
    required: true,
    minLength: 2,
    maxLength: 255,
    pattern: null,
  },
  surname_intl: {
    required: true,
    minLength: null,
    maxLength: null,
    pattern: latinOnlyPattern,
  },
  phone: {
    validate: {
      minLength: isValidPhoneNumber,
    },
  },
  recipient_name: {
    required: true,
    minLength: 2,
    maxLength: 255,
    pattern: cyrOnlyPattern,
  },
  recipient_name_intl: {
    required: true,
    minLength: null,
    maxLength: null,
    pattern: latinOnlyPattern,
  },
  recipient_surname: {
    required: true,
    minLength: 2,
    maxLength: 255,
    pattern: cyrOnlyPattern,
  },
  recipient_surname_intl: {
    required: true,
    minLength: null,
    maxLength: null,
    pattern: latinOnlyPattern,
  },
  recipient_email: {
    required: true,
    pattern: emailPattern,
  },
  recipient_email_intl: {
    required: true,
    pattern: emailPattern,
  },
  // Intl delivery
  country: {
    required: true,
    pattern: allExceptCyrillicPattern,
  },
  region: {
    required: true,
    // Regexp for except cyrillic and spaces only and not nubmers only, letter must be latin only
    // 2. (?![\d\s]+$) - negative lookahead for digits and spaces only
    // 3. [^а-яА-Я]* - any symbol except cyrillic
    // 3.1 [a-zA-Z0-9-.,'&/() ] - any latin symbol, digit, dash, comma, dot, single quote, ampersand, slash, round

    pattern: /^(?![\d\s]+$)[a-zA-Z0-9-.,'&/() ]*$/,
  },
  city: {
    required: true,
    pattern: /^(?![\d\s]+$)[a-zA-Z0-9-.,'&/() ]*$/,
  },
  postcode: {
    required: true,
    pattern: /^(?![\s]+$)[0-9a-zA-Z- ]*$/,
  },
  address: {
    required: true,
    pattern: /^(?![\d\s]+$)[a-zA-Z0-9-.,'&/() ]*$/,
  },
  // Term of use
  term_of_use_confirm: {
    required: true,
  },
}
export const lsPrefix = "uz-ls-"
